import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e = /*#__PURE__*/function () {
  function e(_e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, e);

    this.eventType = _e, this.keyModifiers = t;
  }

  _createClass(e, [{
    key: "matches",
    value: function matches(_e2) {
      if (_e2.type !== this.eventType) return !1;
      if (0 === this.keyModifiers.length) return !0;
      var t = _e2.modifiers;

      var _iterator = _createForOfIteratorHelper(this.keyModifiers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          if (!t.has(i)) return !1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return !0;
    }
  }]);

  return e;
}();

export { e as EventMatch };